<script setup>
import {computed, watch} from 'vue'
import {useFormsStore} from '@/stores/forms'
import {usePageContentDataStore} from '@/stores/pageContentData'
import {usePageEditorStore} from '@/stores/pageEditor'
import PageEditorContentMoveDownBtn from "./PageEditorContentMoveDownBtn.vue"
import PageEditorContentMoveUpBtn from "./PageEditorContentMoveUpBtn.vue"
import PageEditorContentPanelTabBtn from "./PageEditorContentPanelTabBtn.vue"
import PageEditorContentForm from "./PageEditorContentForm"
import PageEditorModified from "./PageEditorModified.vue"

const tabs = [
    {name: 'Edit', icon: 'bi-pencil'},
    {name: 'Scheduling', icon: 'bi-calendar-date'},
    {name: 'Access', icon: 'bi-person-lock'},
    {name: 'Page use', icon: 'bi-diagram-2'},
    {name: 'Settings', icon: 'bi-gear'}
]

const formsStore = useFormsStore()
const pageContentDataStore = usePageContentDataStore()
const pageEditorStore = usePageEditorStore()

const pageContentId = computed(() => pageEditorStore.activePageContentId)
const activeTab = computed(() => pageEditorStore.contentPanelActiveTab)
const pageContent = computed(() => (pageContentDataStore.items || []).find(o => o.id === pageContentId.value))
const contentId = computed(() => pageContent.value?.contentId)
const formId = computed(() => `form:content:${contentId.value}`)

watch(activeTab, async (newTab) => {
    let fieldNames = []
    switch (newTab) {
        case 'Edit':
            fieldNames = ['contentType']
            break
        case 'Scheduling':
            fieldNames = ['validFrom', 'validTo']
            break
        case 'Access':
            fieldNames = ['groupAccess']
            break
        case 'Page use':
            fieldNames = ['pageUse']
            break
        case 'Settings':
            fieldNames = ['']
            break
    }

    await formsStore.createForm({
        tableName: 'content',
        id: contentId.value,
        fieldNames: fieldNames,
        formSmall: true,
        singularLabel: 'content',
        onDelete: () => {
            pageEditorStore.deleteContent(pageContentId.value)
        }
    })
}, {immediate: true})
</script>

<template>
    <section class="d-flex h-100">
        <div v-if="activeTab" class="wrapper flex-fill overflow-scroll">
            <div class="d-flex flex-column h-100">
                <div class="flex-fill p-3 pe-0 me-3">
                    <PageEditorContentForm :form-id="formId" :key="activeTab"/>

                    <div v-if="activeTab === 'Edit'" class="d-grid gap-1 pb-3 text-center">
                        <PageEditorContentMoveUpBtn/>
                        <PageEditorContentMoveDownBtn/>
                    </div>
                </div>

                <footer class="border-top">
                    <PageEditorModified :form-id="formId"/>
                </footer>
            </div>
        </div>

        <div class="d-flex flex-column" style="margin-top: -1px">
            <PageEditorContentPanelTabBtn v-for="tab in tabs" :key="tab.name" :icon-class="tab.icon"
                                          :tab-name="tab.name" :active-tab-prop-name="'contentPanelActiveTab'"
                                          :border-class-name="'border-start'"/>
            <div class="flex-fill bg-body-tertiary border-start"></div>
        </div>
    </section>
</template>

<style scoped>
.wrapper {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.wrapper::-webkit-scrollbar {
    display: none;
}
</style>